export default "acf3efb1b2821c76.svg"